import { Box } from '@mui/material';
import { Outlet } from 'react-router-dom';

const Layout = () => {
  return (
    <Box component="main" className="App">
      <Outlet />
    </Box>
  );
};

export default Layout;
